import {
  listServiceMetrics,
  queryServiceMetricTimeline
} from "Api/metricsExplorer/client";
import {
  ServiceMetricTimelineResponse,
  ServiceMetricsListResponse
} from "Api/metricsExplorer/types";
import { createAppAsyncThunk } from "Store/createAppAsyncThunk";

export type LoadMetricsListArgs = {
  readonly projectId: string;
  readonly environmentId: string;
  readonly service: string;
  readonly fromUnixSeconds: number;
  readonly toUnixSeconds: number;
};

export const loadMetricsList = createAppAsyncThunk<
  ServiceMetricsListResponse,
  LoadMetricsListArgs,
  { rejectValue: { error: string } }
>(
  "metricsExplorer/loadMetricsList",
  async (args, { rejectWithValue, signal }) => {
    try {
      return await listServiceMetrics(args, { signal });
    } catch (error) {
      const message = error instanceof Error ? error.message : "Unknown error";
      return rejectWithValue({ error: message });
    }
  }
);

export type LoadMetricTimelineArgs = {
  readonly projectId: string;
  readonly environmentId: string;
  readonly service: string;
  readonly metricHref: string;
  readonly fromUnixSeconds: number;
  readonly toUnixSeconds: number;
  readonly grainSeconds?: number;
  readonly quantiles?: readonly number[];
};

export const loadMetricTimeline = createAppAsyncThunk<
  ServiceMetricTimelineResponse,
  LoadMetricTimelineArgs,
  { rejectValue: { error: string } }
>(
  "metricsExplorer/loadMetricTimeline",
  async (args, { rejectWithValue, signal }) => {
    try {
      return await queryServiceMetricTimeline(args, { signal });
    } catch (error) {
      const message = error instanceof Error ? error.message : "Unknown error";
      return rejectWithValue({ error: message });
    }
  }
);
